/*---------------------------------------------------------------------------------------------
* Copyright (c) Bentley Systems, Incorporated. All rights reserved.
* See LICENSE.md in the project root for license terms and full copyright notice.
*--------------------------------------------------------------------------------------------*/

import { forwardRef, useEffect } from "react";
import { setPreviewLoaded } from "store/features";
import { useAppDispatch, useAppSelector } from "store/hooks";
import { OverlayButton } from "./OverlayButton";
import { VisualizerInProgress } from "./VisualizerInProgress";
import styles from "./Visualizer.module.css";
import { DeprecationNotice } from "./DeprecationNotice";

export const Visualizer = forwardRef<HTMLIFrameElement>((_, ref) => {
  const status = useAppSelector((state) => state.transpiler.processStatus);
  const layout = useAppSelector((state) => state.settings.layout);
  const itwinjsVersion = useAppSelector((state) => state.activeSandbox.itwinjsVersion);
  const dispatch = useAppDispatch();

  const onLoad = () => {
    dispatch(setPreviewLoaded(true));
  };

  useEffect(() => {
    return () => {
      dispatch(setPreviewLoaded(false));
    }
  }, []);

  return (
    itwinjsVersion === "2.x" || itwinjsVersion === "3.x"
      ? <DeprecationNotice />
      : <div className={styles.visualizer}>
        {status !== "idle" && <VisualizerInProgress status={status} />}
        <iframe
          ref={ref}
          id="sample-frame-container"
          sandbox="allow-same-origin allow-scripts allow-downloads"
          title="iTwinjs Sandbox Preview"
          onLoad={() => onLoad()}
        />
        {((layout.mainHeader === false && layout.popoutButton !== false) || layout.popoutButton) && <OverlayButton />}
      </div>);
});
